module.exports = require('./helpers/bundle-url').getBundleURL('c9iqF') + "bench.11797e29.png";